export default class Thankyou {
  constructor() {
    this.handleCopyButton();
  }

  handleCopyButton() {
    const buttons = document.querySelectorAll(".copy-button");

    buttons.forEach((button) => {
      button.addEventListener("click", () => {
        const text = button.getAttribute("data-text");
        const input = document.querySelector(".copy-input");

        try {
          navigator.clipboard.writeText(text);
          input.select();
        } catch (error) {
          input.select();
          document.execCommand("copy");
        }
      });
    });
  }
}
